import React from 'react';

import constants from '../../lib/constants';

class AllTimeStandings extends React.Component {

    constructor(props) {
        super(props);

        const seasonsData = this.props.seasons;
        const managerList = constants.managerList;

        let allTimeStandingsData = [];

        //init object
        managerList.forEach(key => {
            allTimeStandingsData.push({
                name: key,
                wins: 0,
                losses: 0,
                playoffAppearences: 0,
                pf: 0,
                champ: 0,
                sacko: 0,
            });
        });

        seasonsData.forEach(season => {
            season.regSeason.standings.forEach(player => {
                let playerIndex = managerList.indexOf(player.manager);
                if(playerIndex > -1) {
                    allTimeStandingsData[playerIndex].wins = allTimeStandingsData[playerIndex].wins + player.wins;
                    allTimeStandingsData[playerIndex].losses = allTimeStandingsData[playerIndex].losses + player.losses;
                    allTimeStandingsData[playerIndex].pf = allTimeStandingsData[playerIndex].pf + Number(player.pf || 0);
                    allTimeStandingsData[playerIndex].champ = allTimeStandingsData[playerIndex].champ + Number(player.champ || 0);
                    allTimeStandingsData[playerIndex].sacko = allTimeStandingsData[playerIndex].sacko + Number(player.sacko || 0);
                } else {
                    console.warn('can\'t find manager ' + player.manager);
                }
            });
            let playoffData = season.playoffs;
            playoffData && Object.keys(playoffData.teamData).forEach(playoffContestant => {
                let playerIndex = managerList.indexOf(playoffContestant);
                if(playerIndex > -1) {
                    allTimeStandingsData[playerIndex].playoffAppearences++;
                } else {
                    console.warn('can\'t find manager ' + playoffContestant.manager);
                }
            })
        });

        this.state = {
            allTimeStandingsData: allTimeStandingsData.sort((a, b) => {return b.wins - a.wins}),
            sortWins: null,
            sortPF: null
        }
        this.sortByWins = this.sortByWins.bind(this);
        this.sortByPF = this.sortByPF.bind(this);
    }

    sortByWins() {
        this.setState(state => {
            return {
                allTimeStandingsData: state.allTimeStandingsData.sort((a, b) => {return state.sortWins ? b.wins - a.wins : a.wins - b.wins}),
                sortWins: !state.sortWins
            };
        })
    }

    sortByPF() {
        this.setState(state => {
            return {
                allTimeStandingsData: state.allTimeStandingsData.sort((a, b) => {return state.sortPF ? b.pf - a.pf : a.pf - b.pf}),
                sortPF: !state.sortPF
            };
        })
    }
    
    render() {
        return (
            <div id='allTimeStandings' className='seasonContainer'>
                <h3>All Time Standings</h3>
                <table className="table table-dark table-striped">
                    <thead>
                        <tr>
                            <th scope="col">Name</th>
                            <th scope="col" onClick={this.sortByWins}>W-L<i className="sortIcon bi bi-sort-up"></i></th>
                            <th scope="col" onClick={this.sortByPF}>PF<i className="sortIcon bi bi-sort-up"></i></th>
                            <th scope="col"><i className="trophyParticipant bi bi-trophy-fill"></i></th>
                            <th scope="col"><i className="trophyGold bi bi-trophy-fill"></i></th>
                            <th scope="col"><i className="sackoIcon bi bi-cone-striped"></i></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.allTimeStandingsData.map(allTimeStandingsObject => {
                            return (
                                <tr key={allTimeStandingsObject.name}>
                                    <th scope="row">{allTimeStandingsObject.name}</th>
                                    <td>{allTimeStandingsObject.wins} - {allTimeStandingsObject.losses}</td>
                                    <td>{Math.round(allTimeStandingsObject.pf)}</td>
                                    <td>{allTimeStandingsObject.playoffAppearences}</td>
                                    <td>{allTimeStandingsObject.champ}</td>
                                    <td>{allTimeStandingsObject.sacko}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default AllTimeStandings;